module.exports = __webpack_public_path__ + "static/media/foto-8.c8bf0aab.jpg";